import axios, { InternalAxiosRequestConfig } from 'axios'
import updateToken from '@/services/update-token'
import store from '@/store'
import i18n from '@/i18n'
import router from '@/router'

const APP_VERSION = process.env.VUE_APP_VERSION || 'v1.0.0'
const isMobile =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent,
  )
const FF_CLIENT = `FriendlyFireWeb-${
  isMobile ? 'mobile' : 'desktop'
}/${APP_VERSION}`
const SCREEN_RESOLUTION = `${window.screen.width}x${window.screen.height}`
const TIMEZONE = Intl.DateTimeFormat().resolvedOptions().timeZone

function uuid(): string {
  if (
    typeof crypto !== 'undefined' &&
    typeof crypto.randomUUID === 'function'
  ) {
    return crypto.randomUUID()
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
  })
}

const SESSION_ID_KEY = 'ff_session_id'
function getSessionId(): string {
  let id = sessionStorage.getItem(SESSION_ID_KEY)
  if (!id) {
    id = uuid()
    sessionStorage.setItem(SESSION_ID_KEY, id)
  }
  return id
}

const AUTH_ENDPOINTS = ['login', 'logout', 'refresh-token', 'sso']

const _axios = axios.create()

_axios.interceptors.request.use(async (config: InternalAxiosRequestConfig) => {
  const isAuthEndpoint = AUTH_ENDPOINTS.some((action) =>
    config.url?.includes(action),
  )

  if (!isAuthEndpoint) {
    await updateToken()
  }

  const token = localStorage.getItem('access_token')
  config.headers = config.headers ?? {}
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  config.headers['X-FF-Client'] = FF_CLIENT
  config.headers['X-Screen-Resolution'] = SCREEN_RESOLUTION
  config.headers['X-Timezone'] = TIMEZONE
  config.headers['X-Locale'] = i18n.locale
  config.headers['X-Request-Id'] = uuid()
  config.headers['X-Session-Id'] = getSessionId()

  if (!isAuthEndpoint) {
    config.headers['X-Arena-Id'] = store.state.arena?.id ?? ''
    config.headers['X-Page-Route'] = String(router.currentRoute.name ?? '')
  }

  return config
})

_axios.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    return Promise.reject(error)
  },
)

export default _axios
